module.exports = __webpack_public_path__ + "9025c80dae693e5f87335e00b64f996d.png";